// extracted by mini-css-extract-plugin
export default {"option":"TextFittingControl_option__jlBJq","section":"TextFittingControl_section__v-1MM","hint":"TextFittingControl_hint__ork-0","disabled":"TextFittingControl_disabled__zf5o6"};